import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { AdminMode } from '@/types/global'

export const useAdminStore = defineStore('admin', () => {
  const mode = ref<AdminMode>('quick-actions')

  const $reset = () => {
    mode.value = 'quick-actions'
  }

  const set = (m: AdminMode) => {
    mode.value = m
  }

  return {
    mode,
    $reset,
    set,
  }
})
